module.exports = __webpack_public_path__ + "img/260.06a83cc3.jpg";